export const OPEN = "errorDialog/OPEN";
export const CLOSE = "errorDialog/CLOSE";

export const openErrorDialog = error => ({
  type: OPEN,
  error
});

export const closeErrorDialog = () => ({
  type: CLOSE
});

const initialState = {
  open: false,
  error: {}
};

const errorDialog = (state = initialState, action) => {
  switch (action.type) {
    case OPEN:
      return {
        open: true,
        error: action.error
      };
    case CLOSE:
      return { ...state, open: false };
    default:
      return state;
  }
};

export default errorDialog;



// WEBPACK FOOTER //
// ./src/redux/modules/errorDialog.js